/* eslint-disable camelcase */
import React from 'react'
import PropTypes from 'prop-types'
import georisques from 'assets/pictures/georisques.png'
import logoInsee from 'assets/pictures/logo-insee.png'
import eaufrance from 'assets/pictures/logos/eaufrance.jpg'
import googleMap from 'assets/pictures/logos/googleMap.png'
import ApplicationConf from 'conf/ApplicationConf'
import { push } from '@lagunovsky/redux-react-router'
import HomeAction from 'home/actions/HomeAction'
import HydrometryAction from 'hydrometry/actions/HydrometryAction'
import InstallationAction from 'installation/actions/InstallationAction'
import { template } from 'lodash'
import PiezometryAction from 'piezometry/actions/PiezometryAction'
import PluviometryAction from 'pluviometry/actions/PluviometryAction'
import ProductionUnitAction from 'productionUnit/actions/ProductionUnitAction'
import QualityAction from 'quality/actions/QualityAction'
import { useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import ContactAction from 'referencial/components/contact/actions/ContactAction'
import ContributorAction from 'referencial/components/contributor/actions/ContributorAction'
import i18n from 'simple-react-i18n'
import ToastrAction from 'toastr/actions/ToastrAction'
import useActions from 'utils/customHook/useActions'
import useTitle from 'utils/customHook/useTitle'
import { getValidCodeInput, getValidNameInsee } from 'utils/StringUtil'
import { v4 as uuidv4 } from 'uuid'
import Input from '../../../../components/forms/Input'
import NumberField from '../../../../components/forms/NumberField'
import Select from '../../../../components/forms/Select'
import SieauAction from '../../../../components/sieau/SieauAction'
import Textarea from '../../../../components/forms/Textarea'
import {
    eaufranceCityLink,
    georisquesCityLink,
    googleMapsSearchPath,
    inseeCityLink,
} from '../../../../conf/SieauConstants'
import {
    CITY_LINK,
    PATH_REFERENCIAL,
    PATH_REFERENCIAL_CITY,
    PATH_REFERENCIAL_CITY_LINK,
    PATH_REFERENCIAL_CITY_NEW,
    PATH_REFERENCIAL_RPQS_LINK,
} from '../../../../home/constants/RouteConstants'
import { getSandreList } from '../../../../utils/StoreUtils'
import ReferencialAction from '../../../action/ReferencialAction'
import { FR, SANDRE } from '../../../constants/ReferencialConstants'
import CountryAction from '../../country/actions/CountryAction'
import DeleteModal from '../../DeleteModal'
import ReplaceModal from '../../ReplaceModal'
import CityAction from '../actions/CityAction'
import CityDto from '../dto/CityDto'
import { useParams } from 'react-router'
import { Card, CardContent, Grid } from '@mui/material'
import { ALIGN, CardTable } from 'components/datatable/NewTable'
import { mainBlue } from 'utils/constants/ColorTheme'
import { CardTitle } from 'components/card/NewCard'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'
import Checkbox from 'components/forms/Checkbox'
import useSandreList from 'utils/customHook/useSandreList'
import SuperMultiAutocomplete from 'components/forms/SuperMultiAutocomplete'
import DashboardIcon from '@mui/icons-material/Dashboard'
import LocationPinIcon from '@mui/icons-material/LocationPin'
import MapIcon from '@mui/icons-material/Map'
import ContactsIcon from '@mui/icons-material/Contacts'
import MenuBookIcon from '@mui/icons-material/MenuBook'
import DialogContacts from 'rpqs/components/referentials/components/DialogContacts'
import DialogPopulation from './DialogPopulation'

const typeCedex = { headers: ['cedex'] }
const typeCityHisto = { headers: ['cityCode', 'name'] }

const HEADERS_CONTACTS = ['name', 'phoneTel', 'email', 'socialReason']
const HEADERS_POPULATIONS = ['year', 'totalPopulationINSEE', 'temporaryResidents', 'adjustedTotalPopulation']

const CityApp = ({ rpqs }) => {
    const { code } = useParams()

    const {
        cityProps,
        cities,
        sandreCodes,
        cityCedex,
        countries,
        citiesHisto,
        qualitometersLight,
        piezometersLight,
        installationsLight,
        productionUnits,
        pluviometers,
        hydrometricStations,
        contacts,
        contributors,
        accountUser,
    } = useSelector(store => ({
        cityProps: store.CityReducer.city,
        cities: store.CityReducer.cities,
        sandreCodes: store.ReferencialReducer.sandreCodes,
        cityCedex: store.CityReducer.cityCedex,
        countries: store.CountryReducer.countries,
        citiesHisto: store.CityReducer.citiesHisto,
        qualitometersLight: store.QualityReducer.qualitometersLight,
        piezometersLight: store.PiezometryReducer.piezometersLight,
        installationsLight: store.InstallationReducer.installationsLight,
        productionUnits: store.ProductionUnitReducer.productionUnits,
        pluviometers: store.PluviometryReducer.pluviometers,
        hydrometricStations: store.HydrometryReducer.hydrometricStations,
        contacts: store.ContactReducer.contacts,
        contributors: store.ContributorReducer.contributors,
        accountUser: store.AccountReducer.accountUser,
    }), shallowEqual)

    const [city, setCity] = useState(new CityDto({}))
    const [isEditMode, setIsEditMode] = useState(false)

    const [openDialogContacts, setOpenDialogContacts] = useState(false)
    const [selectedContacts, setSelectedContacts] = useState([])

    const [openDialogPopulation, setOpenDialogPopulation] = useState(false)
    const [selectedPopulation, setSelectedPopulation] = useState([])
    const [defaultValuePopulation, setDefaultValuePopulation] = useState({})
    const [isNewPopulation, setIsNewPopulation] = useState(true)

    const disabled = useMemo(() => ({
        active: isEditMode,
        disabled: !isEditMode,
    }), [isEditMode])

    const getCityLinks = () => {
        if ((!cityProps.countryCode || cityProps.countryCode === FR) && cityProps.code) {
            return [{
                href: template(inseeCityLink)({ code: cityProps.code, lowercaseName: getValidNameInsee(cityProps.name) || '' }),
                img: logoInsee,
                label: i18n.insee.toUpperCase(),
            }, {
                href: georisquesCityLink + cityProps.code,
                img: georisques,
                label: i18n.georisques.toUpperCase(),
            }, {
                href: eaufranceCityLink + cityProps.code,
                img: eaufrance,
                label: i18n.eaufrance.toUpperCase(),
            }, {
                href: googleMapsSearchPath + cityProps.code,
                img: googleMap,
                label: 'Google Maps',
            }]
        }
        return []
    }

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(HomeAction.setHelpLink('', ''))

        if (code !== 'new') {
            dispatch(CityAction.fetchCity(code))
            setIsEditMode(false)
        } else {
            setIsEditMode(true)
        }

        if (!sandreCodes.length) {
            dispatch(ReferencialAction.fetchSandreCodes())
        }
        if (!cityCedex.length) {
            dispatch(CityAction.fetchCityCedex())
        }
        if (!countries.length) {
            dispatch(CountryAction.fetchCountries())
        }
        if (!citiesHisto.length) {
            dispatch(CityAction.fetchCitiesHisto())
        }
        if (!qualitometersLight.length) {
            dispatch(QualityAction.fetchQualitometersLight())
        }
        if (!piezometersLight.length) {
            dispatch(PiezometryAction.fetchPiezometersLight())
        }
        if (!installationsLight.length) {
            dispatch(InstallationAction.fetchInstallationsLight())
        }
        if (!productionUnits.length) {
            dispatch(ProductionUnitAction.fetchProductionUnits())
        }
        if (!pluviometers.length) {
            dispatch(PluviometryAction.fetchPluviometers())
        }
        if (!hydrometricStations.length) {
            dispatch(HydrometryAction.fetchHydrometricStations())
        }
        if (!contacts.length) {
            dispatch(ContactAction.fetchContacts())
        }
        if (!contributors.length) {
            dispatch(ContributorAction.fetchContributors())
        }
    }, [code])

    useEffect(() => {
        setCity(cityProps)
    }, [cityProps])

    useEffect(() => () => dispatch(CityAction.resetCity()), [])

    const checkCode = (callback = () => {}) => {
        const existCode = cities.find(c => c.code === city.code)
        if (existCode) {
            dispatch(ToastrAction.error(i18n.codeAlreadyExists))
        } else if (!city.code && !city.code.length <= 1) {
            dispatch(ToastrAction.error(i18n.thanksToEnterCode))
        } else {
            callback()
        }
    }

    const isConsultant = useMemo(() => accountUser.consultant === '1', [accountUser])

    useTitle(() => {
        if (rpqs) {
            return [{
                title: i18n.rpqs,
                href: 'rpqs',
            }, {
                title: i18n.RPQSReferencials,
                href: PATH_REFERENCIAL_RPQS_LINK,
            }, {
                title: i18n.towns,
                href: PATH_REFERENCIAL_RPQS_LINK + CITY_LINK,
            }, {
                title: code === 'new' ? i18n.new : (code + (cityProps.name ? ` - ${cityProps.name}` : '')),
                href: code === 'new' ? (`${PATH_REFERENCIAL_RPQS_LINK + CITY_LINK}new`) : (PATH_REFERENCIAL_RPQS_LINK + CITY_LINK + code),
            }]
        }
        return [{
            title: i18n.referencials,
            href: PATH_REFERENCIAL,
        }, {
            title: i18n.towns,
            href: PATH_REFERENCIAL_CITY,
        }, {
            title: code === 'new' ? i18n.new : (code + (cityProps.name ? ` - ${cityProps.name}` : '')),
            href: code === 'new' ? PATH_REFERENCIAL_CITY_NEW : PATH_REFERENCIAL_CITY_LINK + code,
        }]
    }, [code, cityProps, rpqs])

    const dataCedex = useMemo(() => cityCedex.filter(cc => cc.cityCode === city.code), [city.code, cityCedex])
    const dataCityHisto = useMemo(() => citiesHisto.filter(ch => ch.cityAttachmentCode === city.code), [citiesHisto, city.code])

    useEffect(() => {
        setSelectedContacts(city?.link_contacts?.map((contact) => contact.contactCode) ?? [])
    }, [city.link_contacts])

    const contactsFiltered = useMemo(() => contacts.filter((contact) => selectedContacts?.find(s => s === contact.id)), [selectedContacts, contacts])

    const dataContacts = useMemo(() => {
        return contactsFiltered.map((contact) => ({
            name: { value: contact.name },
            phoneTel: { value: contact.phoneTel },
            email: { value: contact.email },
            socialReason: { value: contact.socialReason },
        }))
    }, [contactsFiltered])

    useEffect(() => {
        setSelectedPopulation(city.link_populations ?? [])
    }, [city.link_populations])

    const dataPopulation = useMemo(() => selectedPopulation?.map((p) => ({
        year: { value: p.year },
        totalPopulationINSEE: { value: p.inseeTotal },
        temporaryResidents: { value: p.temporaryResident },
        adjustedTotalPopulation: { value: p.increasedTotal },
    })) ?? [], [selectedPopulation])

    const actionsContacts = [{
        icon: 'edit',
        color: 'white',
        displayed: isEditMode,
        onClick: () => {
            setOpenDialogContacts(true)
        },
        tooltip: i18n.addContributor,
    }]

    const actionsPopulations = [{
        icon: 'add',
        displayed: isEditMode,
        onClick: () => {
            setIsNewPopulation(true)
            setOpenDialogPopulation(true)
        },
        tooltip: i18n.addYear,
    }]

    const lineActionsPopulations = [{
        icon: 'edit',
        onClick: (population) => {
            setDefaultValuePopulation(selectedPopulation.find(selectedPopu => selectedPopu.year === population.year.value))
            setIsNewPopulation(false)
            setOpenDialogPopulation(true)
        },
        displayed: isEditMode,
        align: ALIGN.RIGHT,
    }, {
        icon: 'delete',
        align: ALIGN.RIGHT,
        onClick: (e) => {
            setSelectedPopulation(selectedPopulation.filter(popu => popu.year !== e.year.value))
        },
        displayed: isEditMode,
    }]

    useActions(() => {
        if (isConsultant) {
            return {}
        }
        const links = getCityLinks()
        const isNewActions = code === 'new' && (!cityProps || !cityProps.code)
        const { code: cityCode, ...cityWithoutCode } = city
        const formattedCity = {
            ...cityWithoutCode,
            id: cityCode,
            ...(contactsFiltered.length && {
                link_contacts: contactsFiltered.map((contact) => ({
                    cityCode: code,
                    contactCode: contact.id,
                    contactFunction: contact.contactFunction,
                })),
            }),
            ...(selectedPopulation.length && {
                link_populations: selectedPopulation.map((e) => ({
                    cityCode: code,
                    year: e.year,
                    increasedTotal: e.increasedTotal,
                    increasedTotalAuto: false,
                    inseeTotal: e.inseeTotal,
                    inseeTotalAuto: false,
                    temporaryResident: e.temporaryResident,
                    temporaryResidentAuto: false,
                })),
            }),
            link_postalCode: [],
        }
        const actions = (() => {
            if (isNewActions) {
                return {
                    save: () => checkCode(() => {
                        dispatch(CityAction.createCity(formattedCity, rpqs && (PATH_REFERENCIAL_RPQS_LINK + CITY_LINK + formattedCity.id)))
                        dispatch(CityAction.fetchCities())
                        setIsEditMode(false)
                    }),
                    cancel: () => {
                        dispatch(push(rpqs ? `${PATH_REFERENCIAL_RPQS_LINK}city` : PATH_REFERENCIAL_CITY))
                        setIsEditMode(false)
                    },
                }
            }
            if (isEditMode) {
                return {
                    save: () => {
                        dispatch(CityAction.updateCity({
                            ...formattedCity,
                            id: city.code.toString(),
                            link_postalCode: cityProps.link_postalCode?.filter(p => p !== '') ?? [],
                            addressCityName: (city.addressCityName && city.addressCityName !== '') ? city.addressCityName : city.name,
                        }, city.code))
                        dispatch(CityAction.fetchCities())
                        setIsEditMode(false)
                    },
                    cancel: () => {
                        setCity(cityProps)
                        setSelectedContacts(city?.link_contacts?.map((contact) => contact.contactCode))
                        setIsEditMode(false)
                    },
                }
            }
            return {
                edit: () => {
                    setIsEditMode(true)
                },
                deleteCheck: () => {
                    dispatch(ReferencialAction.fetchCheckDelete(ApplicationConf.referencial.cityCountDelete(code)))
                    const id = uuidv4()
                    const popup = {
                        id,
                        content: <DeleteModal
                            onDelete={() => dispatch(CityAction.deleteCity(city.code, rpqs && (PATH_REFERENCIAL_RPQS_LINK + CITY_LINK)))}
                        />,
                        dismissible: false,
                    }
                    dispatch(SieauAction.setPopup(popup))
                },
                replace: () => {
                    dispatch(ReferencialAction.fetchCheckDelete(ApplicationConf.referencial.cityCountDelete(code)))
                    const id = uuidv4()
                    const popup = {
                        id,
                        content: <ReplaceModal
                            elements={ cities }
                            title={`${i18n.city} [${city.code}]`}
                            label={i18n.city}
                            onReplace={ (newCode) => dispatch(CityAction.replaceCity(city.code, newCode.code)) }
                        />,
                        dismissible: false,
                    }
                    dispatch(SieauAction.setPopup(popup))
                },
            }
        })()
        return (!isNewActions && !isEditMode && links.length > 0) ? { ...actions, links } : actions
    }, [isConsultant, code, cityProps, city, isEditMode, selectedContacts, selectedPopulation, rpqs])

    return (
        <>
            <Grid container spacing={1}>
                <Grid container size={6} direction='column' spacing={1}>
                    <Card>
                        <CardTitle title={ i18n.description } icon={<DashboardIcon fontSize='large' />} />
                        <CardContent>
                            <Grid container spacing={1}>
                                <Grid size={3}>
                                    <Input
                                        title={ i18n.code }
                                        value={ city.code }
                                        onChange={ newCode => setCity({ ...city, code: getValidCodeInput(newCode) }) }
                                        maxLength={ 12 }
                                        disabled={ code !== 'new' }
                                    />

                                </Grid>
                                <Grid size={9}>
                                    <Input
                                        title={ i18n.name }
                                        value={ city.name }
                                        onChange={ name => setCity({ ...city, name }) }
                                        maxLength={ 35 }
                                        { ...disabled }
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <Select
                                        label={ i18n.country }
                                        value={ city.countryCode }
                                        options={ countries }
                                        keyValue='countryCode'
                                        nullLabel='&nbsp;'
                                        onChange={ countryCode => setCity({ ...city, countryCode }) }
                                        { ...disabled }
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <Select
                                        options={ getSandreList(sandreCodes, SANDRE.COMMUNES_SITUATION) }
                                        label={ i18n.situation }
                                        onChange={ situation => setCity({ ...city, situation }) }
                                        value={ parseInt(city.situation) }
                                        nullLabel='&nbsp;'
                                        { ...disabled }
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <Select
                                        options={ getSandreList(sandreCodes, 'PREL_AGRI.SECTEUR_CLIMATIQUE') }
                                        label={ i18n.climateSector }
                                        onChange={ climateSector => setCity({ ...city, climateSector }) }
                                        value={ parseInt(city.climateSector) }
                                        nullLabel='&nbsp;'
                                        keyLabel='referenceWithLabel'
                                        { ...disabled }
                                    />
                                </Grid>
                                <Grid size={6}/>
                                <Grid size={4}>
                                    <Input
                                        title={ i18n.siren }
                                        value={ city.siren }
                                        onChange={ siren => {
                                            setCity({ ...city, siren })
                                        } }
                                        maxLength={ 14 }
                                        { ...disabled }
                                    />
                                </Grid>
                                <Grid size={2}>
                                    <SimpleDatePicker
                                        label={ i18n.creationDate }
                                        value={ city.creationDate }
                                        onChange={ creationDate => {
                                            setCity({ ...city, creationDate })
                                        } }
                                        { ...disabled }
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <Input
                                        title={ i18n.sispeaCode }
                                        value={ city.sispeaCode }
                                        onChange={ sispeaCode => {
                                            setCity({ ...city, sispeaCode })
                                        } }
                                        maxLength={ 14 }
                                        { ...disabled }
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <SuperMultiAutocomplete
                                        label={i18n.waterAgency}
                                        options={contributors}
                                        values={ city.agency }
                                        onChange={ agency => {
                                            setCity({ ...city, agency })
                                        } }
                                        {...disabled}
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <CardTable
                                        title={ i18n.cedexList }
                                        color={mainBlue}
                                        row={ dataCedex }
                                        headers={typeCedex.headers}
                                        headersLabel={{ cedex: i18n.cedexCode }}
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    <Card>
                        <CardTitle title={i18n.skillsDirectlyApplied} icon={<MenuBookIcon fontSize='large' />}/>
                        <CardContent>
                            <Grid container spacing={1}>
                                <Grid container size={6} alignItems='center'>
                                    <Checkbox
                                        label={ i18n.usageDrink }
                                        checked={city.skillAEP}
                                        onChange={ skillAEP => {
                                            setCity({ ...city, skillAEP })
                                        }}
                                        { ...disabled }
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <Input
                                        title={ i18n.code }
                                        value={ city.codeSkillAEP }
                                        onChange={ codeSkillAEP => {
                                            setCity({ ...city, codeSkillAEP })
                                        }}
                                        { ...disabled }
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    <Card>
                        <CardTitle title={i18n.address} icon={<LocationPinIcon fontSize='large'/>}/>
                        <CardContent>
                            <Grid container spacing={1}>
                                <Grid size={6}>
                                    <Select
                                        label={i18n.function}
                                        options={useSandreList(SANDRE.CONTACT_FONCTION)}
                                        value={ city.addressFunction }
                                        onChange={addressFunction => setCity({ ...city, addressFunction })}
                                        {...disabled}
                                    />
                                </Grid>
                                <Grid offset={6}/>
                                <Grid size={6}>
                                    <Input
                                        title={ i18n.address }
                                        value={ city.address }
                                        onChange={ address => setCity({ ...city, address }) }
                                        { ...disabled }
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <Input
                                        title={ i18n.addressComplement }
                                        value={ city.addressComplement }
                                        onChange={ addressComplement => setCity({ ...city, addressComplement }) }
                                        { ...disabled }
                                    />
                                </Grid>
                                <Grid size={3}>
                                    <Input
                                        title={ i18n.postalCode }
                                        value={ city.postalCode }
                                        onChange={ postalCode => setCity({ ...city, postalCode }) }
                                        { ...disabled }
                                    />
                                </Grid>
                                <Grid size={9}>
                                    <Input
                                        title={ i18n.city }
                                        value={ city.addressCityName }
                                        onChange={ addressCityName => setCity({ ...city, addressCityName }) }
                                        { ...disabled }
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid container size={6} direction='column' spacing={1}>
                    <Card>
                        <CardTitle title={ i18n.localisation} icon={<MapIcon fontSize='large'/>} />
                        <CardContent>
                            <Grid container spacing={1}>
                                <Grid size={6}>
                                    <NumberField
                                        title={ i18n.area }
                                        value={ city.area }
                                        onChange={ area => setCity({ ...city, area }) }
                                        { ...disabled }
                                        floatValue
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <Select
                                        options={ getSandreList(sandreCodes, SANDRE.PROJECTION) }
                                        label={ i18n.projection }
                                        onChange={ projection => setCity({ ...city, projection }) }
                                        value={ city.projection }
                                        nullLabel='&nbsp;'
                                        { ...disabled }
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <NumberField
                                        floatValue
                                        title={ i18n.x }
                                        value={ city.x }
                                        onChange={ x => setCity({ ...city, x }) }
                                        { ...disabled }
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <NumberField
                                        floatValue
                                        title={ i18n.y }
                                        value={ city.y }
                                        onChange={ y => setCity({ ...city, y }) }
                                        { ...disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Textarea
                                        title={ i18n.km_polygon }
                                        value={ city.kml }
                                        onChange={kml => setCity({ ...city, kml }) }
                                        { ...disabled }
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    <CardTable
                        title={ i18n.associatedCities }
                        rows={ dataCityHisto }
                        headers={typeCityHisto.headers}
                    />
                    <Card>
                        <CardTitle title={i18n.contacts} icon={<ContactsIcon fontSize='large'/>} />
                        <CardContent>
                            <Grid container spacing={1}>
                                <Grid size={6}>
                                    <Input
                                        title={ i18n.phone }
                                        value={ city.phone }
                                        onChange={ phone => setCity({ ...city, phone }) }
                                        { ...disabled }
                                    />
                                </Grid>
                                <Grid size={6}>
                                    <Input
                                        title={ i18n.email }
                                        value={ city.email }
                                        onChange={ email => setCity({ ...city, email }) }
                                        { ...disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <Input
                                        title={ i18n.openDaysAndTimes }
                                        value={ city.openHours }
                                        onChange={ openHours => setCity({ ...city, openHours }) }
                                        { ...disabled }
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <CardTable
                                        title={i18n.contacts}
                                        rows={dataContacts}
                                        headers={HEADERS_CONTACTS}
                                        actions={actionsContacts}
                                        color={mainBlue}
                                    />
                                </Grid>
                            </Grid>

                        </CardContent>
                    </Card>
                    <CardTable
                        title={ i18n.population }
                        rows={ dataPopulation }
                        headers={HEADERS_POPULATIONS}
                        actions={actionsPopulations}
                        lineActions={lineActionsPopulations}
                    />
                </Grid>
            </Grid>
            <DialogContacts
                open={openDialogContacts}
                onClose={() => {
                    setSelectedContacts(city?.link_contacts?.map((contact) => contact.contactCode))
                    setOpenDialogContacts(false)
                }}
                onValidate={() => setOpenDialogContacts(false)}

                contacts={contacts}
                selectedContacts={selectedContacts}
                setSelectedContacts={setSelectedContacts}
            />
            <DialogPopulation
                open={openDialogPopulation}
                setOpen={setOpenDialogPopulation}
                cityCode={parseInt(code)}

                populations={selectedPopulation}
                setPopulations={setSelectedPopulation}

                defaultValue={defaultValuePopulation}
                setDefaultValue={setDefaultValuePopulation}
                isNew={isNewPopulation}
                setIsNew={setIsNewPopulation}
            />
        </>
    )
}

CityApp.propTypes = {
    rpqs: PropTypes.bool,
}

export default CityApp